import { StyleSheet } from 'react-native';
import { LIGHT_GREY_COLOR, RED_COLOR } from 'coooltv-js-shared/src/styles/common';

export const WHITE_COLOR = '#ffffff';
export const BLUE_COLOR = '#0080b4';
export const GREY_COLOR = '#6e7482';
export const HOVERED_COLOR = '#dcdcdc';

export const commonStyles = StyleSheet.create({
    input: {
        fontFamily: 'Open Sans',
        fontWeight: 300,
        fontSize: 18,
        color: GREY_COLOR,
        width: 470,
        height: 50,
        borderWidth: 1,
        borderStyle: 'solid',
        paddingLeft: 10,
        borderColor: BLUE_COLOR,
        borderRadius: 8,
        marginBottom: 20,
    },
    input_phone: {
        fontFamily: 'Open Sans',
        fontWeight: 300,
        fontSize: 16,
        color: GREY_COLOR,
        height: 40,
        borderWidth: 1,
        borderStyle: 'solid',
        paddingLeft: 10,
        borderColor: BLUE_COLOR,
        borderRadius: 8,
        marginBottom: 20,
    },
    error: {
        fontSize: 16,
        textAlign: 'center',
        color: RED_COLOR,
        width: '100%',
    },
});

export const tableRowOdd = {
    flexDirection: 'row',
    height: 40,
    alignItems: 'center',
    paddingLeft: 10,
    paddingRight: 10,
    backgroundColor: WHITE_COLOR,
};

export const tableRowEven = {
    ...tableRowOdd,
    backgroundColor: LIGHT_GREY_COLOR,
};

export const tableRowEvenPhone = {
    ...tableRowEven,
    height: 80,
};

export const tableRowOddPhone = {
    ...tableRowOdd,
    height: 80,
};

export const tableRowOddHovered = {
    ...tableRowOdd,
    backgroundColor: HOVERED_COLOR,
};

export const tableRowEvenHovered = {
    ...tableRowEven,
    backgroundColor: HOVERED_COLOR,
};

export const tableRowEvenPhoneHovered = {
    ...tableRowEvenPhone,
    backgroundColor: HOVERED_COLOR,
};

export const tableRowOddPhoneHovered = {
    ...tableRowOddPhone,
    backgroundColor: HOVERED_COLOR,
};

export const actionButton = {
    alignSelf: 'center',
    height: 15,
    width: 15,
};

export const actionButtonPhone = {
    ...actionButton,
    margin: 'auto',
};

export const dragButtonContainer = {
    flexBasis: '5%',
    width: '100%',
    height: '100%',
    color: GREY_COLOR,
    fontSize: 16,
    alignSelf: 'center',
};

export const dragButtonContainerPhone = {
    ...dragButtonContainer,
    flexBasis: '10%',
    display: 'flex',
    justifyContent: 'center',
};
